import axios from '@/plugins/axios';
import { generateFilterParams } from '../helpers.js';

const state = {
  items: [],
  loading: false,
  pagination: {
    sortDesc: [true],
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
  },
  filters: {},
  totalItems: 0,
  user: {},
};

const mutations = {
  setItems: (currentState, { items, totalItems }) => {
    currentState.items = items;
    currentState.totalItems = totalItems;
  },
  setItem: (currentState, item) => {
    const index = currentState.items.findIndex((x) => x.id === item.id);
    currentState.items[index].isActive = item.isActive;
  },
  setUser: (currentState, item) => {
    currentState.user = item;
  },
  setPagination: (currentState, payload) => {
    currentState.pagination = payload;
  },
  setFilters: (currentState, payload) => {
    currentState.filters = { ...payload };
  },
  setLoading: (currentState, payload) => {
    currentState.loading = payload;
  },
};

const actions = {
  getItems({ commit, state: currentState }) {
    return new Promise((resolve) => {
      commit('setLoading', true);
      const params = {
        page: state.pagination.page,
        rowsPerPage: state.pagination.itemsPerPage,
        sortBy: state.pagination.sortBy[0],
        descending: state.pagination.sortDesc[0],
        ...generateFilterParams(currentState.filters),
      };
      axios
        .get('/users', { params })
        .then((response) => {
          commit('setItems', response.data);
          resolve();
        })
        .finally(() => commit('setLoading', false));
    });
  },
  getUser({ commit }, id) {
    return new Promise((resolve) => {
      axios
        .get(`/users/${id}`)
        .then((response) => {
          commit('setUser', response.data);
          resolve();
        });
    });
  },
  updateUser({ dispatch }, item) {
    return new Promise((resolve) => {
      axios
        .put(`users/${item.id}`, item)
        .then(() => {
          dispatch('getUser', item.id);
          resolve();
        });
    });
  },
  setPagination({ commit, dispatch }, paginationInfo) {
    commit('setPagination', paginationInfo);
    dispatch('getItems');
  },
  setFilters({ commit, dispatch }, filters) {
    state.pagination.page = 1;
    commit('setFilters', filters);
    dispatch('getItems');
  },
  toggleActivation({ commit }, item) {
    return new Promise((resolve) => {
      commit('setLoading', true);
      axios
        .put(`/users/${item.id}/active`, { isActive: !item.isActive })
        .then((response) => {
          commit('setItem', response.data);
          resolve();
        })
        .finally(() => commit('setLoading', false));
    });
  },
};

const getters = {
  loading(currentState) {
    return currentState.loading;
  },
  pagination(currentState) {
    return currentState.pagination;
  },
  tableItems(currentState) {
    return [...currentState.items.map((user) => ({
      ...user,
      financeCompanies: user.financeCompanies.map((x) => x.code).join(','),
      createdAt: user.createdAt?.substring(0, 10),
      providerInfo: {
        ...user.providerInfo,
        membershipRenewsAt: user.providerInfo?.membershipRenewsAt?.substring(0, 10),
      },
    })),
    ];
  },
  downloadUrl(currentState) {
    const filterParams = generateFilterParams(currentState.filters);
    return `${axios.defaults.baseURL}users/download?${
      Object.keys(filterParams).map((key) => `${key}=${filterParams[key]}`).join('&')}`;
  },
  currentUser(currentState) {
    return {
      email: currentState.user.emailAddress,
      name: currentState.user.name,
      phoneNumber: currentState.user.phoneNumber,
      addressOne: currentState.user.address?.line1,
      addressTwo: currentState.user.address?.line2,
      cityName: currentState.user.address?.city,
      state: currentState.user.address?.state,
      zip: currentState.user.address?.zip,
      submittingEntity: currentState.user.submittingEntity,
      dealershipId: currentState.user.dealerInfo?.dealerIdNumber,
      dealershipName: currentState.user.dealerInfo?.primaryContactName,
      financeCompany: currentState.user.financeCompanies?.map((x) => x.code).join(','),
    };
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
